import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import {
  faAnglesDown,
  faCircleExclamation,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';

export const reserve_status = {
  ALL: '',
  CREATED: 'CREATED',
  SOLVED: 'SOLVED',
  properties: {
    all: {
      display_name: 'Statut',
    },
    CREATED: {
      display_name: 'À traiter',
      color: '#FA983A',
    },
    SOLVED: {
      display_name: 'Résolue',
      color: '#6B6B6B',
    },
  },
};

export const reserves_types = {
  ALL: '',
  RESERVE: 'RESERVE',
  RESERVE_CLIENT: 'RESERVE_CLIENT',
  RESERVE_ITEM: 'RESERVE_ITEM',
  'UNABLE-TO-DELIVER': 'UNABLE-TO-DELIVER',
  CHECKLIST: 'CHECKLIST',
  TOUR: 'TOUR',
  STEP: 'STEP',
  null: null,
  properties: {
    all: {
      display_name: 'Tous les types',
    },
    RESERVE: {
      display_name: 'Réserve BL',
      color: 'orange',
      icon: faCircleExclamation,
    },
    RESERVE_CLIENT: {
      display_name: 'Réserve client',
      color: 'orange',
      icon: faCircleExclamation,
    },
    RESERVE_ITEM: {
      display_name: 'Réserve produit',
      color: 'orange',
      icon: faCircleExclamation,
    },
    'UNABLE-TO-DELIVER': {
      display_name: 'Livraison impossible',
      color: 'red',
      icon: faCircleXmark,
    },
    CHECKLIST: {
      display_name: 'Réserve checklist',
      color: '#6B6B6B',
      icon: faWarning,
    },
    TOUR: {
      display_name: 'Réserve tournée',
      color: '#C2C2C2',
      icon: faAnglesDown,
    },
    STEP: {
      display_name: 'Réserve étape',
      color: '#C2C2C2',
      icon: faAnglesDown,
    },
    null: {
      display_name: 'Réserve',
      color: '#C2C2C2',
      icon: faAnglesDown,
    },
  },
};
